export const ADDRESS_TYPES = {
  SHIPPING: 'SHIPPING',
  BILLING: 'BILLING',
}

export const NORMALIZATION_STATUS = {
  VALID: 'VALID',
  INVALID: 'INVALID',
  CONFIRMATION_REQUIRED: 'CONFIRMATION_REQUIRED',
  NOT_ATTEMPTED: 'NOT_ATTEMPTED',
}

export const POSTAL_NORMALIZATION_STATUS = {
  UNKNOWN: 'UNKNOWN',
  NORMALIZED: 'NORMALIZED',
  NORMALIZATION_REJECTED: 'NORMALIZATION_REJECTED',
}

export const VALIDATION_RESULT_CODE = {
  UNSUPPORTED_COUNTRY: 'UNSUPPORTED_COUNTRY',
  PO_BOX_UNSUPPORTED: 'PO_BOX_UNSUPPORTED',
  US_TERRITORY_UNSUPPORTED: 'US_TERRITORY_UNSUPPORTED',
  INVALID_ADDRESS: 'INVALID_ADDRESS',
  ADDRESS_REGION_NOT_SUPPORTED: 'ADDRESS_REGION_NOT_SUPPORTED',
}

export const isAddressValidated = (address = {}) => {
  const { confirmed, postalNormalizationStatus } = address
  const { NORMALIZED } = POSTAL_NORMALIZATION_STATUS

  const isConfirmed = confirmed === true
  const isNormalized = postalNormalizationStatus === NORMALIZED
  return [isConfirmed, isNormalized].some((condition) => condition === true)
}

export const isBillingAddressType = (addressType = '') => addressType === ADDRESS_TYPES.BILLING

export const isShippingAddressType = (addressType = '') => addressType === ADDRESS_TYPES.SHIPPING

export const getNormalizationStatusForVerifiedAddress = (normalizationStatus) => {
  const { NORMALIZED } = POSTAL_NORMALIZATION_STATUS
  const { VALID, CONFIRMATION_REQUIRED } = NORMALIZATION_STATUS
  let normalizationStatusValue

  if ([VALID, CONFIRMATION_REQUIRED].includes(normalizationStatus)) {
    normalizationStatusValue = NORMALIZED
  }

  return normalizationStatusValue
}
